import echarts from 'echarts';
import dayjs from "dayjs";

const index = {
  name:'index',
  data() {
    return {
      wareCode: '',
      isNew: true, // 是否是新的类目信息
      commodityTbLoad: false, // 商品走势表格 加载
      cdParam: {}, // 获取列表入参
      cdList: [],  //  商品数据列表数据
      isSearch: false, // 是否正在搜索 处理第一次搜索会调用loadmore
      likeCommodity: '', // 模糊查询 商品名
      page: 1, // 当前分页
      key: '', // 获取列表所需key
      loadOver:false, // 无限加载是否完毕

      commodityTitle: '', //商品类目名称
      showDialog: false, // 是否显示弹框

      commodityLastDate: '', // 上次更新时间
      timeType: '1', // 老的走势时间类型
      oldExportUrl:'', // 老的走势导出地址
      cpTimeList: [
        {
          label: '1w',
          name: '1'
        }, {
          label: '1mo',
          name: '2'
        }, {
          label: '1yr',
          name: '3'
        }, {
          label: 'All',
          name: '4'
        }
      ],
      commodityChartData: [], //  老的商品数据折线数据

      latestKey:'', // 详情获取最新信息的key
      latestMsg:{},
      categoryMsg: {},


      period: '1D', // 当前走势类型
      cpTabsList: [
        {
          label: this.$t('ctCommodity.tabs1D'),
          name: '1D'
        }, {
          label: this.$t('ctCommodity.tabsD'),
          name: 'd'
        }, {
          label: this.$t('ctCommodity.tabsW'),
          name: 'w'
        }, {
          label: this.$t('ctCommodity.tabsM'),
          name: 'm'
        }, {
          label: this.$t('ctCommodity.tabsY'),
          name: 'y'
        },
      ], // 新的走势 tab类型
      moreType: this.$t('ctCommodity.more'),
      moreOptions: [
        {
          value: '1',
          label: '1' + this.$t('ctCommodity.tabsMoreM')
        }, {
          value: '5',
          label: '5' + this.$t('ctCommodity.tabsMoreM')
        }, {
          value: '15',
          label: '15' + this.$t('ctCommodity.tabsMoreM')
        }, {
          value: '30',
          label: '30' + this.$t('ctCommodity.tabsMoreM')
        }, {
          value: '60',
          label: '60' + this.$t('ctCommodity.tabsMoreM')
        },
      ],

      rowData: null, // 当前点击的商品数据对象
      chartLoad: false, // 图表数据加载中
      chart: null, //  商品折线图
      options:null, // 图表配置
      cdData: [], // 走势图数据
      kData: null, //  k线数据
      maData: '', // 均价MA 数据
      isEmpty:false, // 是否是造的空数据
      tooltipShow: false, // 默认不展示，鼠标移动才展示
      tooltipData: '', // 右上角信息数据
      xPosVal:'',
      xPos:false, // 提示信息的位置 左上角 或右上角
      vol: '', // 成交量
      showPointer:true, // 是否展示图标上的 坐标轴指示器 数据量少于30，补充的空数据不展示

      keyInterval: null, // 获取key 的定时器 15s 一次
      listInterval: null, // 通过key 轮询获取列表数据的定时器 1s 一次
      latestInterval:null, // 通过key获取最新价格信息的 定时器

      firstTime: {},// 第一次调用详情数据的时间
      curTime: '', // 当前时间
      timeInterval: null, // 时间定时器

      firstRequest:true, // 是否第一次请求 图表数据
      zoomStart:0, // 缩放数据开始位置
      zoomEnd:100, // 缩放数据结束位置
      isAllData:false, // 是否是全部的走势数据
      preLoading:false, // 是否正在加载历史数据
    }
  },
  methods: {
    toggle(){
      this.$emit('toggleClick');
    },
    handleInit(obj) {
      let _this = this;
      if (obj) {
        _this.cdParam = obj;
        _this.wareCode = _this.cdParam['wareCode']
      }
      _this.resetList();

      _this.page = 1;
      // _this.cdList = [];
      _this.loadOver = false;
      _this.firstTime = _this.setTime();
      _this.getKey();

      this.keyInterval = window.setInterval(()=>{
        _this.curTime = _this.setTime();
        if((_this.curTime.se -_this.firstTime.se)%15 === 0){
          console.log('当前时间秒：'+_this.curTime.se);
          // console.log(_this.curTime.se -_this.firstTime.se);
          // _this.initList();
          _this.getKey();
        }
      },1000);

    }, // 初始化信息

    initList(){
      let _this = this;
      _this.page = 1;
      // _this.cdList = [];
      _this.isSearch = true;
      _this.loadOver = false;
      _this.$refs.list.$el.children[2].scrollTop = 0 // 定位到头部
    },

    resetList(){
      let _this = this;
      window.clearInterval(_this.keyInterval);
      window.clearInterval(_this.listInterval);
    }, // 重置数据

    getKey() {
      let _this = this;
      window.clearInterval(_this.listInterval);
      _this.cdParam = Object.assign(_this.cdParam, {
        likeCommodity: _this.likeCommodity,
        page: _this.page
      });
      _this.commodityTbLoad = true;
      this.axios.post('/api/zma/loan/getTrendList', _this.cdParam).then(res => {
        if (res.status && res.data) {
          _this.key = res.data;
          _this.queryProductList();
        } else {
          _this.commodityTbLoad = false;
          _this.$message.error(_this.$t(`ctError.${res.errorCode}`));
        }

      })
    }, // 获取行情列表数据 所需key

    queryProductList() {
      let _this = this;
      window.clearInterval(_this.listInterval);
      let param = {
        key:_this.key
      };
      // _this.commodityTbLoad = true;
      this.axios.post('/api/zma/loan/getWareDataList', param).then(res => {
        if (res.status === 2) {
          // console.log('处理中！！！！！！！');
          _this.listInterval = window.setInterval(() => {
            _this.queryProductList();
          }, 1000)
        }else{
          // console.log(_this.key+'++clearInterval 前 ！！！！！！！');
          window.clearInterval(_this.listInterval);
          // console.log('clearInterval 后:'+_this.listInterval);

          _this.infiniteLoad = false;
        }

        if (res.status === 1) {
          _this.isSearch = false;

          if(res.data.tableList < 1){
            _this.loadOver = true;
          }
          _this.cdList = [];
          _this.cdList = res.data.tableList;
          // if (_this.page === 1) {
          //   _this.cdList = [];
          //   _this.cdList = res.data.tableList;
          // } else {
          //   _this.cdList = _this.cdList.concat(res.data.tableList);
          // }

        } else if(res.status === 0){
          _this.$message.error(_this.$t(`ctError.${res.errorCode}`));
        }

      })
    },// 获取商品走势列表数据

    handleSearch() {
      let _this = this;
      _this.initList();
      _this.firstTime = _this.setTime();
      _this.searchAnswer();
    }, // 模糊搜索商品

    infiniteLoad() {
      let _this = this;
      if (_this.isSearch || _this.loadOver) {
        return;
      }
      _this.page++;
      console.log('infiniteLoad:' + _this.page);
      _this.getKey()
    }, // 无线加载

    // 列表相关 ========================================================================= end



    handleDetail(e) {
      // console.log(e.row);
      let _this = this;
      if(_this.chart){
        _this.chart.clear();
      }
      _this.resetList();

      _this.rowData = e.row;
      _this.isNew = _this.rowData.isFuntrues;

      _this.commodityTitle = _this.rowData.name;
      _this.categoryDate = _this.rowData.date;

      _this.commodityCount(); // 点击次数统计

      if (_this.isNew) {
        _this.period = '1D';
        // _this.period = 'd';
        _this.moreType= _this.$t('ctCommodity.more');
        _this.firstTime = _this.setTime();
        // console.log(_this.firstTime);
        _this.handleTime();
        _this.queryCategory(); //获取当前商品类别
        _this.queryLatestKey(); // 获取实时最新信息key

        _this.firstRequest = true;
        _this.isAllData = false;
        _this.queryDetail(); //获取新的走势详情

      } else {
        _this.timeType = '1';
        _this.queryDetailOld();
      }

      _this.showDialog = true;

    }, // 商品数据name点击打开 走势图

    commodityCount(){
      let _this = this;
      let param = {
        categoryCode:_this.rowData.categoryCode
      };
      this.axios.post('/api/zma/loan/savestatisticsUserVisitCommodity', param).then(res => {
        if (res.status) {
        } else {
          _this.$message.error(_this.$t(`ctError.${res.errorCode}`));
        }
      })
    },

    setTime() {
      return {
        week: new Date().getDay(), // 星期
        y: new Date().getFullYear(), // 年
        m: new Date().getMonth() + 1,
        d: new Date().getDate(),
        ho: new Date().getHours(),
        mi: new Date().getMinutes(),
        se: new Date().getSeconds()
      };
    }, // 设置时间

    handleTime() {
      let _this = this;
      _this.timeInterval = window.setInterval(() => {
        _this.curTime = _this.setTime();// 实时获取date
        // console.log(_this.period === '1D' && _this.curTime.mi > _this.firstTime.mi && _this.curTime.se === _this.firstTime.se);

        if((_this.curTime.se -_this.firstTime.se)%15 === 0){
          _this.queryLatestKey(); // 获取实时最新信息
        }
        _this.firstRequest = false;
        if (_this.period === '1D' && _this.curTime.se === _this.firstTime.se) {
          console.log(_this.curTime.mi + ':'+ _this.curTime.se + '分时及k线轮训');
          _this.queryDetail();
        } else if (_this.period === 'd' && _this.curTime.ho === 0 && _this.curTime.mi === 0 && _this.curTime.se === 0) {
          console.log('d--k线轮训');
          _this.queryDetail();
        } else if (_this.period === 'w' && _this.curTime.week === 1 && _this.curTime.ho === 0 && _this.curTime.mi === 0 && _this.curTime.se === 0) {
          console.log('w--k线轮训');
          _this.queryDetail();
        } else if (_this.period === 'y' && _this.curTime.m ===1 && _this.curTime.d === 1 && _this.curTime.ho ===0 && _this.curTime.mi ===0 && _this.curTime.se === 0) {
          console.log('y--k线轮训');
          _this.queryDetail();
        } else if (_this.period === '6' && _this.moreType === '1' && _this.curTime.se === 0) {
          console.log(_this.curTime.ho +':'+_this.curTime.mi + ':'+ _this.curTime.se +'==1分--k线轮训');
          _this.queryDetail();
        } else if (_this.period === '6' && _this.moreType === '5' && _this.curTime.mi % 5 === 0 && _this.curTime.se === 0) {
          console.log(_this.curTime.ho +':'+_this.curTime.mi + ':'+ _this.curTime.se +'==5分--k线轮训');
          _this.queryDetail();
        } else if (_this.period === '6' && _this.moreType === '15' && _this.curTime.mi % 15 === 0 && _this.curTime.se === 0) {
          console.log(_this.curTime.ho +':'+_this.curTime.mi + ':'+ _this.curTime.se +'==15分--k线轮训');
          _this.queryDetail();
        } else if (_this.period === '6' && _this.moreType === '30' && _this.curTime.mi % 30 === 0 && _this.curTime.se === 0) {
          console.log(_this.curTime.ho +':'+_this.curTime.mi + ':'+ _this.curTime.se +'==30分--k线轮训');
          _this.queryDetail();
        } else if (_this.period === '6' && _this.moreType === '60' && _this.curTime.mi ===0 && _this.curTime.se === 0) {
          console.log(_this.curTime.ho +':'+_this.curTime.mi + ':'+ _this.curTime.se +'==60分--k线轮训');
          _this.queryDetail();
        }
      }, 1000);
    }, // 时间定时器

    queryDetailOld() {
      // 1：一周；2：一月；3：一年；4：所有
      let _this = this;
      let param = {
        w_type: _this.timeType,
        w_code:_this.rowData.categoryCode,
      };
      _this.chartLoad = true;
      this.axios.post('/api/zma/loan/getWareData', param).then(res => {
        if (res.status) {
          let data = res.data;
          _this.oldExportUrl = res.data.downUrl;
          _this.commodityLastDate = data.lastDate;
          _this.commodityChartData = data.oneCategory;
          if (_this.commodityTitle.length === 0) {
            _this.commodityTitle = data.oneCategory[0].name;
          }
          window.setTimeout(() => {
            _this.chartLoad = false;
            _this.renderChart();
          }, 0);
        } else {
          _this.$message.error(_this.$t(`ctError.${res.errorCode}`));
        }
      })
    }, // 老的走势查询接口

    queryCategory() {
      let _this = this;
      let param = {
        categoryId: _this.rowData.categoryId
      };
      this.axios.post('/api/zma/loan/getcategorybychildid', param).then(res => {
        if (res.status) {
          _this.categoryMsg = res.data;
        } else {
          _this.$message.error(_this.$t(`ctError.${res.errorCode}`));
        }
      })
    }, // 获取类目相关信息

    queryLatestKey() {
      let _this = this;
      window.clearInterval(_this.latestInterval);
      let param = {
        futruesEncode: _this.rowData.futruesEncode,
        categoryCode: _this.rowData.categoryCode,
        categoryId: _this.rowData.categoryId
      };
      this.axios.post('/api/zma/loan/getlastpricebycategorycodeasyn', param).then(res => {
        if (res.status) {
          _this.latestKey = res.data;
          _this.queryLatest();
          // _this.latestInterval = setInterval(() => {
          //   _this.queryLatest();
          // }, 1000)
        } else {
          _this.$message.error(_this.$t(`ctError.${res.errorCode}`));
        }
      })
    }, // 获取最新价格涨跌额和涨跌幅 key

    queryLatest() {
      let _this = this;
      let param = {
        key:_this.latestKey
      };
      window.clearInterval(_this.latestInterval);
      this.axios.post('/api/zma/loan/getlastpricebyredis', param).then(res => {

        if (res.status === 2) {
          // console.log('latest 处理中！！！！！！！');
          _this.latestInterval = window.setInterval(() => {
            _this.queryLatest();
          }, 1000)
        }else{
          window.clearInterval(_this.latestInterval);
        }

        if (res.status===1) {
          _this.latestMsg = res.data;
          _this.latestMsg.isUp = _this.dealChg(_this.latestMsg.change);

        } else if (res.status===0){
          _this.$message.error(_this.$t(`ctError.${res.errorCode}`));
        }
      })
    }, // 获取最新价格涨跌额和涨跌幅 具体信息

    queryDetail(type) { // type 是否是查询之前的历史数据 1-是的  0-不是
      let _this = this;
      let url = '';
      let firstTime = '';
      let lastTime = '';

      firstTime = !_this.firstRequest && _this.cdData.length>0 && type ===1 ? _this.cdData[0].time :'';  // 查询更多历史数据需要
      lastTime = !_this.firstRequest && _this.cdData.length>0  && type !==1 ? _this.cdData[_this.cdData.length-1].time :'';  // 非第一次请求需要传 最后一个时间

      let param = {
        futruesEncode: _this.rowData.futruesEncode,
        categoryCode: _this.rowData.categoryCode,
        firstRequest: _this.firstRequest, // 是否第一次请求
        lastTime: lastTime,
        firstTime:firstTime
      };

      if (_this.period === '1D') {
        url = '/api/zma/loan/gettimelinelist';
      } else {
        url = '/api/zma/loan/getklinelist';
        param = Object.assign(param, {
          period: _this.period === '6' ? _this.moreType : _this.period,
        })
      }

      _this.chartLoad = true;
      this.axios.post(url, param).then(res => {
        if (res.status) {
          let data = res.data;
          _this.preLoading = false;
          if(data.clearData){
            _this.cdData = [];
            _this.kData = null;
            if(_this.chart){
              _this.chart.clear();
            } // 重置走势

            if(data.list.length>0){
              _this.cdData = data.list;
              setTimeout(() => {
                _this.renderChart();
              }, 0);
            }

          }// 如果第一次请求，清空数据，重绘图表

          _this.isAllData = (data.clearData || type===1) && data.list.length<980 ? true : false;
          // 第一次获取数据，或者查询历史数据 不超过990 说明没有更多历史数据

          if(!data.clearData && data.list && data.list.length>0){
            if(type ===1 ){ // 往前追加数据
              _this.cdData = data.list.concat(_this.cdData);
            }else{ // 往后追加数据
              _this.cdData = _this.cdData.concat(data.list);
            }

            let addData = _this.splitData(data.list,1);
            // console.log(addData);
            let ope = 'push';
            if(lastTime) {
              ope = 'push';
            } // 定时器 往后追加
            if(firstTime){
              ope = 'unshift';
            } // 拖拽或缩放到头部 往前追加
            _this.options.xAxis[0].data[ope](...addData.categoryData);
            _this.options.series[0].data[ope](...addData.volume);

            if (_this.period === '1D'){
              _this.options.series[1].data[ope](...addData.price);
              _this.options.series[2].data[ope](...addData.averagePrice);
            }else{
              _this.options.series[1].data[ope](...addData.values);
              _this.options.series[2].data[ope](...addData.ma5);
              _this.options.series[3].data[ope](...addData.ma10);
              _this.options.series[4].data[ope](...addData.ma20);
              _this.options.series[5].data[ope](...addData.ma30);
              // console.log(data.list.length*100/_this.cdData.length);
              _this.options.dataZoom[0].start = firstTime ? (data.list.length*100/_this.cdData.length).toFixed(0): _this.zoomStart;
              _this.options.dataZoom[0].end = _this.zoomEnd;
            }

            _this.chart.setOption(_this.options);
          } // 不是第一次请求 追加数据

          _this.tooltipData = _this.cdData[_this.cdData.length-1];

        } else if(res.status===0){
          _this.$message.error(_this.$t(`ctError.${res.errorCode}`));
        }
        _this.chartLoad = false;
      })
    }, // 新的走势查询接口

    renderMsg(params) {

      let _this = this;
      let dataIndex =params[0].dataIndex;

      if(_this.isNew){
        if(_this.kData.categoryData[dataIndex]){
          _this.isEmpty = false;
        }else{
          _this.isEmpty = true;
        } // 空数据不显示 弹框明细
      }

      if (_this.isNew && _this.cdData[dataIndex]) {
        _this.tooltipData = _this.cdData[dataIndex];
      }else if(_this.commodityChartData[dataIndex]){
        _this.tooltipData = _this.commodityChartData[dataIndex];
      }

    }, // 根据选中数据 渲染信息

    splitData(rawData, type) { // type = 1 少于20条的数据不需要处理
      let _this = this;

      if(rawData.length<20 && type !==1){
        let addArrLength = 20-rawData.length;
        let arr = Array(addArrLength);
        let itemObj = rawData.slice(0,1)[0];
        let newObj = {};
        Object.keys(itemObj).forEach(key=>{
          newObj[key] = '';
        });
        arr.fill(newObj);

        // console.log(rawData);
        rawData = rawData.concat(arr);
        // console.log(rawData);
      } // 处理数据量少于30 的情况，将数据填充到 30个

      let categoryData = [];
      let volume=[];

      let price = [];
      let averagePrice = [];

      let values = [];
      let ma5 = [];
      let ma10 = [];
      let ma20 = [];
      let ma30 = [];

      for (let i = 0; i < rawData.length; i++) {
        // let item = [];
        categoryData.push(rawData[i].time);
        volume.push(rawData[i].volume);

        if (_this.period === '1D'){
          price.push(rawData[i].price);
          averagePrice.push(rawData[i].averagePrice)
        }else{
          ma5.push(rawData[i].ma5);
          ma10.push(rawData[i].ma10);
          ma20.push(rawData[i].ma20);
          ma30.push(rawData[i].ma30);
          values.push(_this.renderKline(rawData[i]))
          // item.push(rawData[i].open, rawData[i].close, rawData[i].low, rawData[i].hight);
          // values.push(item);
        }
      }

      if(_this.period === '1D'){
        return {
          categoryData: categoryData,
          volume:volume,
          price:price,
          averagePrice:averagePrice
        };
      }else{
        return {
          categoryData: categoryData,
          volume:volume,
          values: values,
          ma5: ma5,
          ma10: ma10,
          ma20: ma20,
          ma30: ma30,
        };
      }

    }, // 拆分整理数据

    renderChart() {
      let _this = this;
      let options;
      // console.log(_this.period);
      _this.chart = echarts.init(_this.$refs.dialogEchart);
      if (_this.isNew) { // 新的走势图
        _this.kData = _this.splitData(_this.cdData);

        _this.zoomStart = 0;
        _this.zoomEnd = 100;
        if(_this.cdData.length < 50){
          _this.zoomStart = 0;
        }else{
          _this.zoomStart = ((_this.cdData.length - 50)*100/_this.cdData.length).toFixed(0);
        }
        // console.log('start:'+start);
        if (_this.period === '1D') { // 分时图
          options = {
            animationDuration:0,
            tooltip: {
              axisPointer: {
                type: 'cross'
              },
              trigger: 'axis',
              position: function (pos) {
                // console.log(pos);
                _this.xPosVal= pos[0];
                _this.xPos = pos[0]>580 ? true : false;
              },
              formatter: function (params) {
                if (params.length > 0) {
                  _this.renderMsg(params)
                }
              },
            },
            axisPointer: {
              show: true,
              type: 'line',
              link: {
                xAxisIndex: 'all'
              },
              lineStyle: {
                color: '#81899E'
              },
              label: {
                backgroundColor: '#81899E',
                margin: 5,
                shadowBlur: 0,
                padding: [4, 5, 3, 5],
              }
            },
            xAxis: [
              {
                show: true,
                gridIndex: 1,
                data: _this.kData.categoryData,
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#CACACA'
                  },
                },
                axisLabel: {
                  color: '#81899E'
                },
                axisTick: {
                  show: false
                },
                axisPointer: {
                  label: {
                    show: true
                  }
                },
                min: 'dataMin',
                max: 'dataMax',
              },
              {
                show: true,
                gridIndex: 0,
                data: _this.kData.categoryData,
                axisLabel: {
                  color: '#81899E'
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#CACACA'
                  }
                },
                axisTick: {
                  show: false
                },
                axisPointer: {
                  label: {
                    show: false
                  }
                },
                min: 'dataMin',
                max: 'dataMax',
              }
            ],
            yAxis: [
              {
                scale: true,
                gridIndex: 1,
                axisLabel: {
                  color: '#81899E'
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#CACACA'
                  }
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: true,
                  onZero: false,
                  lineStyle: {
                    color: '#eeeef0',
                    type: 'dashed'
                  }
                },
                axisPointer: {
                  lineStyle: {
                    color: '#81899E',
                    type: 'solid'
                  }
                },
                // min: 'dataMin',
                // max: 'dataMax',
              },
              {
                scale: true,
                gridIndex: 0,
                axisLabel: {
                  color: '#81899E'
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#CACACA'
                  }
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: false,
                },
                axisPointer: {
                  lineStyle: {
                    color: '#81899E',
                    type: 'solid'
                  }
                },
                // min: 'dataMin',
                // max: 'dataMax',
              },
            ],
            grid: [
              {
                show: true,
                left: 92,
                right: 42,
                top: '85%',
                height: '14%',
                borderColor: '#CACACA',
              },
              {
                show: true,
                left: 92,
                right: 42,
                top: 40,
                height: '66%',
                borderColor: '#CACACA',
              },
            ],
            // dataZoom: [
            //   {
            //     show: false,
            //     realtime: true,
            //     start: 0,
            //     end: 100,
            //     top: '96%',
            //     bottom: '00%',
            //     xAxisIndex: [0, 1],
            //     minValueSpan:20
            //   },
            //   {
            //     type: 'inside',
            //     realtime: true,
            //     start: 0, // dataZoom百分比
            //     end: 100,
            //     top: '95%',
            //     bottom: '00%',
            //     xAxisIndex: [0, 1]
            //   }
            // ],
            series: [
              {
                name: 'vol',
                data: _this.kData.volume,
                type: 'bar',
                smooth: true,
                xAxisIndex: 1, // 指定x轴
                yAxisIndex: 1, // 指定y轴
                lineStyle: {
                  normal: {
                    color: '#ADAECE'
                  }
                },
                itemStyle: {
                  normal: {
                    color: '#ADAECE',
                    borderColor: '#ADAECE',
                  }
                },
                animationDuration:0
              },
              {
                name: '1D',
                data: _this.kData.price,
                type: 'line',
                symbol: 'none',
                // symbolSize:1,
                lineStyle: {
                  normal: {
                    color: '#0073FF',
                    width: 1
                  }
                },
                itemStyle: {
                  normal: {
                    color: '#0073FF',
                    borderColor: '#0073FF',
                  }
                },
                areaStyle: { //区域填充样式
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(47, 139, 253,0.3)'
                    }, {
                      offset: 0.6,
                      color: 'rgba(47, 139, 253,0.2)'
                    }, {
                      offset: 1,
                      color: 'rgba(47, 139, 253,0.02)'
                    }
                    ], false),
                    shadowBlur: 0
                  }
                },
                animationDuration:0
              },
              {
                name: '1D均线',
                data: _this.kData.averagePrice,
                type: 'line',
                symbol: 'none',
                // symbolSize:1,
                lineStyle: {
                  normal: {
                    color: '#FE892B',
                    width: 1
                  }
                },
                itemStyle: {
                  normal: {
                    color: '#FE892B',
                    borderColor: '#FE892B',
                  }
                },
                animationDuration:0
              },
            ]
          };
        } else { // k线图
          // _this.tooltipData = _this.cdData[_this.cdData.length-1];
          _this.kData = _this.splitData(_this.cdData);

          options = {
            animationDuration:0,
            animationThreshold:980, //开启动画的阈值
            tooltip: {
              axisPointer: {
                type: 'cross'
              },
              // show: true,
              trigger: 'axis',
              position: function (pos) {
                // console.log(pos);, params, el, elRect, size
                _this.xPosVal= pos[0];
                _this.xPos = pos[0]>580 ? true : false;
              },
              formatter: function (params) {
                if (params.length > 0) {
                  _this.renderMsg(params)
                }
              },
            },
            axisPointer: {
              show: _this.showPointer,
              type: 'line',
              link: {
                xAxisIndex: 'all'
              },
              lineStyle: {
                color: '#81899E'
              },
              label: {
                backgroundColor: '#81899E',
                margin: 5,
                shadowBlur: 0,
                // height:20,
                // lineHeight:20,
                padding: [4, 5, 3, 5],
              }
            },
            xAxis: [
              {
                show: true,
                gridIndex: 1,
                data: _this.kData.categoryData,
                min: 'dataMin',
                max: 'dataMax',
                // splitNumber: 20,
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#CACACA'
                  },
                },
                axisLabel: {
                  color: '#81899E'
                },
                axisTick: {
                  show: false
                },
                axisPointer: {
                  label: {
                    show: true
                  }
                }
              },
              {
                show: true,
                gridIndex: 0,
                data: _this.kData.categoryData,
                min: 'dataMin',
                max: 'dataMax',
                // splitNumber: 20,
                axisLabel: {
                  color: '#81899E'
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#CACACA'
                  }
                },
                axisTick: {
                  show: true
                },
                axisPointer: {
                  label: {
                    show: false
                  }
                }
              }
            ],
            yAxis: [
              {
                gridIndex: 1,
                scale: true,
                axisLabel: {
                  color: '#81899E'
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#CACACA'
                  }
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#eeeef0',
                    type: 'dashed'
                  }
                },
                axisPointer: {
                  lineStyle: {
                    color: '#81899E',
                    type: 'solid'
                  }
                },
                // min: 'dataMin',
                // max: 'dataMax',
              },
              {
                gridIndex: 0,
                scale: true,
                axisLabel: {
                  color: '#81899E'
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#CACACA'
                  }
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: false,
                },
                axisPointer: {
                  lineStyle: {
                    color: '#81899E',
                    type: 'solid'
                  }
                },
                // min: 'dataMin',
                // max: 'dataMax',
              },
            ],
            grid: [
              {
                show: true,
                left: 92,
                right: 42,
                top: '85%',
                height: '14%',
                borderColor: '#CACACA',
              },
              {
                show: true,
                left: 92,
                right: 42,
                top: 40,
                height: '66%',
                borderColor: '#CACACA',
              },
            ],
            dataZoom: [
              {
                show: false,
                realtime: true,
                start: _this.zoomStart,
                end: _this.zoomEnd,
                xAxisIndex: [0, 1],
                minValueSpan:19,
                maxValueSpan:200,
              },
              {
                type: 'inside',
                realtime: true,
                start: _this.zoomStart, // dataZoom百分比
                end: _this.zoomEnd,
                xAxisIndex: [0, 1]
              }
            ],
            series: [
              {
                name: 'vol',
                data: _this.kData.volume,
                type: 'bar',
                smooth: true,
                xAxisIndex: 1, // 指定x轴
                yAxisIndex: 1, // 指定y轴
                barMaxWidth:20,
                lineStyle: {
                  normal: {
                    color: '#ADAECE'
                  }
                },
                itemStyle: {
                  normal: {
                    color: '#ADAECE',
                    borderColor: '#ADAECE',
                  }
                },
              },
              {
                name: 'candlestick',
                data: _this.kData.values,
                // data:_this.renderKline(_this.cdData),
                type: 'candlestick',
                barMaxWidth:20,
                itemStyle: {
                  normal: {
                    // color: '#13AF6B',
                    // color0: '#E44245',
                    borderColor: null,
                    borderColor0: null
                  }
                },
              },
              {
                name: 'MA5',
                data: _this.kData.ma5,
                type: 'line',
                symbol: 'none',
                lineStyle: {
                  normal: {
                    color: '#E71515',
                    width: 1
                  }
                },
                markPoint: {
                  symbol: 'arrow'
                },
                itemStyle: {
                  normal: {
                    color: '#E71515',
                    borderColor: '#E71515',
                  }
                }
              },
              {
                name: 'MA10',
                data: _this.kData.ma10,
                type: 'line',
                symbol: 'none',
                lineStyle: {
                  normal: {
                    color: '#C739D1',
                    width: 1
                  }
                },
                itemStyle: {
                  normal: {
                    color: '#C739D1',
                    borderColor: '#C739D1',
                  }
                }
              },
              {
                name: 'MA20',
                data: _this.kData.ma20,
                type: 'line',
                symbol: 'none',
                lineStyle: {
                  normal: {
                    color: '#E1AB2C',
                    width: 1
                  }
                },
                itemStyle: {
                  normal: {
                    color: '#E1AB2C',
                    borderColor: '#E1AB2C',
                  }
                }
              },
              {
                name: 'MA30',
                data: _this.kData.ma30,
                type: 'line',
                symbol: 'none',
                lineStyle: {
                  normal: {
                    color: '#0073FF',
                    width: 1
                  }
                },
                itemStyle: {
                  normal: {
                    color: '#0073FF',
                    borderColor: '#0073FF',
                  }
                }
              },
            ]
          };
        }
      } else { // 老的走势图
        let data = _this.commodityChartData;

        options = {
          tooltip: {
            trigger: 'axis',
            position: function (pos) {
              // console.log(pos); , params, el, elRect, size
              _this.xPosVal= pos[0];
              _this.xPos = pos[0]>580 ? true : false;
            },
            formatter: function (params) {
              if (params.length > 0) {
                _this.renderMsg(params)
              }
            },
          },
          grid: {
            show: true,
            left: 60,
            top: 18,
            right: 18,
            borderColor: '#CACACA',
          }, //折线图居左、居右间距
          xAxis: {
            type: 'category',
            data: data.map(function (item) {
              return item.date;
            }),
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#CACACA'
              },
            },
            axisLabel: {
              color: '#81899E'
            },
            axisTick: {
              show: false
            },
            axisPointer: {
              label: {
                show: true
              }
            }
          },//横坐标属性
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#81899E'
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#CACACA'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#eeeef0',
                type: 'dashed'
              }
            },
            axisPointer: {
              lineStyle: {
                color: '#81899E',
                type: 'solid'
              }
            },
          },//纵坐标属性
          axisPointer: {
            show: true,
            type: 'line',
            link: {
              xAxisIndex: 'all'
            },
            lineStyle: {
              color: '#81899E'
            },
            label: {
              backgroundColor: '#81899E',
              margin: 5,
              shadowBlur: 0,
              padding: [4, 5, 3, 5],
            }
          },
          series: {
            name: 'oldCommodity',
            type: 'line',
            data: data.map(function (item) {
              return item.settle;
            }),
            lineStyle: {
              normal: {
                color: '#0073FF',
                width: 1
              }
            },
            itemStyle: {
              normal: {
                color: '#0073FF',
                borderColor: '#0073FF',
              }
            },
            symbol: 'none'
          }
        };
      }
      _this.options = options;
      _this.chart.setOption(options);

      _this.chart.on('dataZoom',function(event){
        // console.log(event);
        if(event.batch){
          _this.zoomStart=event.batch[0].start;
          _this.zoomEnd=event.batch[0].end;
          if(_this.zoomStart === 0 && !_this.isAllData){
            _this.firstRequest = false;
            if(_this.preLoading){
              return false;
            }
            _this.preLoading = true;
            console.log('zoomStart----------'+_this.zoomStart)
            _this.queryDetail(1);
          }
        }
      });
      // setTimeout(() => {
      //   _this.chart.resize();
      // }, 0)
    }, // 渲染图表

    renderKline(val){
      let color = '';
      if(val.status === 0){
        color = '#E44245';
      }else if(val.status === 1){
        color = '#13AF6B';
      }else if(val.status === 2){
        color = '#999999';
      }
      let item =[];
      item.push(val.open, val.close, val.low, val.hight);
      // values.push(item);
      return {
        value:item,
        itemStyle:{
          color:color,
          color0:color
        }
      }
    }, // 动态配置 蜡烛图的颜色

    tabChange(tab) {
      // console.log(tab.name);
      this.moreType=this.$t('ctCommodity.more');
      if (this.isNew) {
        this.firstRequest = true;
        this.isAllData = false;
        this.queryDetail();
        this.queryLatestKey();
        this.firstTime = this.setTime();
      } else {
        this.queryDetailOld();
      }
    }, // tab切换监听
    moreChange() {
      // console.log(this.moreType);
      this.period = '6';
      this.firstTime = this.setTime();
      this.firstRequest = true;
      this.isAllData = false;
      this.queryDetail();
      this.queryLatestKey();
    }, // more 下拉监听

    // echartsOver(e) {
    //   this.tooltipShow = this.xPosVal >92 && this.xPosVal < 1053 ? true : false;
    // },
    echartsLeave() {
      this.tooltipShow = false;
    },

    echartsMove(e){
      // console.log('e.offsetX:'+e.offsetX);
      if((this.isNew && e.offsetX > 92 && e.offsetX<1048 && e.offsetY>40) || (!this.isNew && e.offsetX > 60 && e.offsetX<1072 && e.offsetY>18)){
        if(this.isEmpty){
          this.tooltipShow = false;
        }else{
          this.tooltipShow = true;
        }
      }else{
        this.tooltipShow = false;
        this.tooltipData = this.cdData[this.cdData.length-1];
      }
    },

    handleDown() {
      console.log('down');
      let _this = this;
      let fileName = '';

      if(_this.cdData.length === 0){
        _this.$message.error(_this.$t('ctCommodity.downEmpty'));
        return false;
      }
      if(!_this.isNew){
        window.open(_this.oldExportUrl);
        return false;
      }
      let dataJson='';
      if(_this.cdData.length>1000){
        dataJson = _this.cdData.slice(_this.cdData.length-1000);
      }else{
        dataJson = _this.cdData;
      }

      if(_this.period === '1D'){
        fileName= _this.commodityTitle + dayjs().format('YYYYMMDD')+'.xlsx';
      }else{
        let kName = _this.$t('ctCommodity.kName');
        fileName= _this.commodityTitle + '_'+ kName + dayjs().format('YYYYMMDD')+'.xlsx';
      }
      // console.log(fileName);
      let param = {
        period: _this.period === '6' ? _this.moreType : _this.period,
        dataJson:JSON.stringify(dataJson)
      };

      _this.axios.post('/api/zma/loan/exportdata', param,{responseType:'blob'}).then(res => {
        const blob = new Blob([res]);

        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        // console.log(elink.href);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      })
    }, // 下载

    dealChg(data){
      let num=parseFloat(data);
      let isUp = '';
      if(num>0){
        isUp = 'up';
      }else if(num<0){
        isUp = 'down';
      }else{
        isUp='';
      }
      return isUp;
    }, // 处理 change 样式
    dealStatus(status){
      let num=parseInt(status);
      let isUp = '';
      if(num===0){
        isUp = 'down';
      }else if(num===1){
        isUp = 'up';
      }else{
        isUp='';
      }
      return isUp;
    },

    handleClose() {
      console.log('handle close');
      this.showDialog = false;
      window.clearInterval(this.timeInterval);
      window.clearInterval(this.latestInterval);
      this.isSearch = true;
      this.handleInit();
    }, // 关闭弹框 关闭详情页面定时器，并重新拉去列表信息
  },
  created: function () {
    this.searchAnswer = this._.debounce(this.getKey, 500)
  },
  mounted() {
    // console.log('======================='+dayjs().format('YYYYMMDD'))
  },
  beforeDestroy() {
    window.clearInterval(this.keyInterval);
    window.clearInterval(this.listInterval);
  },
}

export default index
